module.exports = __webpack_public_path__ + "media/images/ig-stories-aebf7ccc6c3b76a00671cc77238a2f15.png";